{
  "AGENT_BOTS": {
    "HEADER": "Botai",
    "LOADING_EDITOR": "Įkeliama redagavimo priemonė...",
    "DESCRIPTION": "Agent Bots are like the most fabulous members of your team. They can handle the small stuff, so you can focus on the stuff that matters. Give them a try.You can manage your bots from this page or create new ones using the 'Configure new bot' button.",
    "LEARN_MORE": "Learn about agent bots",
    "GLOBAL_BOT_BADGE": "Sistema",
    "AVATAR": {
      "SUCCESS_DELETE": "Boto avataras sėkmingai ištrintas",
      "ERROR_DELETE": "Klaida trinant boto avatarą, bandykite dar kartą"
    },
    "CSML_BOT_EDITOR": {
      "NAME": {
        "LABEL": "Boto Pavadinimas",
        "PLACEHOLDER": "Name your bot.",
        "ERROR": "Yra reikalingas Boto vardas."
      },
      "DESCRIPTION": {
        "LABEL": "Boto Aprašymas",
        "PLACEHOLDER": "Ką daro šis botas?"
      },
      "BOT_CONFIG": {
        "ERROR": "Įveskite CSML boto konfigūraciją aukščiau.",
        "API_ERROR": "Jūsų CSML konfigūracija neteisinga. Pataisykite ją ir bandykite dar kartą."
      },
      "SUBMIT": "Patvirtinkite ir išsaugokite"
    },
    "BOT_CONFIGURATION": {
      "TITLE": "Pasirinkite agento botą",
      "DESC": "Assign an Agent Bot to your inbox. They can handle initial conversations and transfer them to a live agent when necessary.",
      "OPTION": "{name} ({description})",
      "SUBMIT": "Atnaujinti",
      "DISCONNECT": "Atsijungti Botą",
      "SUCCESS_MESSAGE": "Sėkmingai atnaujintas agento botas.",
      "DISCONNECTED_SUCCESS_MESSAGE": "Sėkmingai atjungtas agento botas.",
      "ERROR_MESSAGE": "Nepavyko atnaujinti agento boto. Bandykite dar kartą vėliau.",
      "DISCONNECTED_ERROR_MESSAGE": "Nepavyko ajungti agento boto. Bandykite dar kartą vėliau.",
      "SELECT_PLACEHOLDER": "Pasirinkti Botą",
      "COUNTRY_BOTS": {
        "TITLE": "Botai pagal šalį",
        "DESC": "Ši gautųjų dėžutė aptarnauja kelias šalis. Pokalbis perduodamas jo šalies botui: pagal Kaufland parduotuvę, Allegro užsakymo prekyvietę, o jei jų nėra, pagal kalbą, kuria rašo klientas. Visi kiti pokalbiai perduodami aukščiau nurodytam numatytajam botui.",
        "COUNTRY": "Pasirinkite šalį",
        "BOT": "Pasirinkite botą",
        "ADD": "Pridėti šalies botą",
        "REMOVE": "Pašalinti",
        "DEFAULT_REQUIRED": "Pirmiausia pasirinkite numatytąjį botą. Šalies botas jį pakeičia tik tai šaliai.",
        "DISCONNECT_ALL": "Atjungti visus botus"
      }
    },
    "ADD": {
      "TITLE": "Konfigūruoti naują botą",
      "CANCEL_BUTTON_TEXT": "Atšaukti",
      "API": {
        "SUCCESS_MESSAGE": "Botas pridėtas sėkmingai.",
        "ERROR_MESSAGE": "Nepavyko pridėti boto. Bandykite dar kartą vėliau."
      }
    },
    "LIST": {
      "404": "Botų nerasta, galite sukurti botą spustelėdami mygtuką „Konfigūruoti naują robotą“ ↗",
      "LOADING": "Gaunami Botai...",
      "TABLE_HEADER": {
        "DETAILS": "Boto informacija",
        "URL": "Webhook URL"
      },
      "TYPE": "Boto Tipas"
    },
    "DELETE": {
      "BUTTON_TEXT": "Ištrinti",
      "TITLE": "Ištrinti Botą",
      "CONFIRM": {
        "TITLE": "Patvirtinti Ištrynimą",
        "MESSAGE": "Ar tikrai norite ištrinti {name}?",
        "YES": "Taip, ištrinti",
        "NO": "Ne, palikti"
      },
      "SUBMIT": "Ištrinti",
      "CANCEL_BUTTON_TEXT": "Atšaukti",
      "DESCRIPTION": "Ar tikrai norite ištrinti šį botą? Šis veiksmas yra neatšaukiamas.",
      "API": {
        "SUCCESS_MESSAGE": "Botas ištrintas sėkmingai.",
        "ERROR_MESSAGE": "Nepavyko ištrinti boto. Bandykite dar kartą."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "Redaguoti",
      "LOADING": "Gaunami Botai...",
      "TITLE": "Keisti Botą",
      "CANCEL_BUTTON_TEXT": "Atšaukti",
      "API": {
        "SUCCESS_MESSAGE": "Botas atnaujintas sėkmingai.",
        "ERROR_MESSAGE": "Nepavyko atnaujinti boto. Bandykite dar kartą vėliau."
      }
    },
    "FORM": {
      "AVATAR": {
        "LABEL": "Boto avataras"
      },
      "NAME": {
        "LABEL": "Boto pavadinimas",
        "PLACEHOLDER": "Įveskite boto pavadinimą"
      },
      "DESCRIPTION": {
        "LABEL": "Aprašymas",
        "PLACEHOLDER": "Ką daro šis botas?"
      },
      "WEBHOOK_URL": {
        "LABEL": "Webhook URL",
        "PLACEHOLDER": "https://example.com/webhook"
      },
      "ERRORS": {
        "NAME": "Būtinas boto pavadinimas",
        "URL": "Būtinas Webhook URL",
        "VALID_URL": "Įveskite tinkamą URL, prasidedantį http:// arba https://"
      },
      "CANCEL": "Atšaukti",
      "CREATE": "Sukurti botą",
      "UPDATE": "Atnaujinti botą"
    },
    "TYPES": {
      "WEBHOOK": "Boto Webhook",
      "CSML": "CSML Bot"
    }
  }
}
